import React from 'react';
import Image from 'app/Components/Shared/Image/image';
const FamilyMemberPackageUsage = ({serviceIcon, mobile, name, usage}) => {
  return (
    <div className='family-member-package-usage-container'>
      <Image src={serviceIcon} className='service-icon' />
      <div className='member-info'>
        <span className='member-mobile'>{mobile}</span>
        <span className='member-name'>{name}</span>
      </div>
      <span className='member-usage'>{usage}</span>
    </div>
  );
};

export default FamilyMemberPackageUsage;
